import type { ReactNode } from "react";
import { useVenueEntitlements } from "./entitlements";
import { Upgrade } from "../pages/Upgrade";

/**
 * ADVISORY entitlement guard — the entitlement equivalent of [RequireVenueRole]. Renders [children] only
 * when the current venue has [feature] enabled; otherwise the upgrade screen. Nav entries declare the SAME
 * feature and are filtered through the same `has`, so a hidden feature can never be reached by a link — this
 * guard only catches direct navigation / deep links. The server re-enforces the feature fail-closed on every
 * action regardless; this makes no authorization decision beyond rendering.
 */
export function RequireEntitlement({
  feature,
  children,
}: {
  feature: string;
  children: ReactNode;
}) {
  const { has } = useVenueEntitlements();
  if (!has(feature)) return <Upgrade feature={feature} />;
  return <>{children}</>;
}
